import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { border, flex } from "shared/theme/mixins";
import FormControlLabel from "@mui/material/FormControlLabel";
import Select from "shared/components/Form/Select";
import { BORDER, COLOR_GREY_6, COLOR_GREY_5, COLOR_WHITE, COLOR_BLACK } from "shared/theme/colors";

export const StyledContainer = styled(Box)`
  ${flex({ fd: "column" })};
  ${border(1, COLOR_GREY_6)};
  gap: 0.5rem;
  border-radius: 0.75rem;
  padding: 1rem;
`;

export const StyledRowContainer = styled(Box)`
  ${flex({ fd: "row" })};
  gap: 1rem;
`;

export const StyledSelect = styled(Select)`
  &.MuiInput-root .MuiNativeSelect-select {
    padding: 0 2rem 0 1rem;
    border-radius: 0.5rem;
    height: 40px;
    background-color: ${COLOR_WHITE};
    border: ${BORDER(1, COLOR_GREY_5)};
  }
`;

export const StyledFormLabel = styled(FormControlLabel)`
  &.MuiFormControlLabel-root .MuiFormControlLabel-label {
    color: ${COLOR_BLACK};
    font-size: 0.75rem;
    font-weight: 700;
  }
`;